/**
 * Menu and Mavigation Element Handlers.
 *
 * @author Introspective
 * @see    https://github.com/jranby
 */
jQuery(document).ready(function($) {

    /*
     * Menu Toggle Click Hanglefr
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    $('.menu-toggler').on('click', function(e) {
        e.preventDefault();
        $('.mobile-menu-container').toggleClass('d-none');
        $('html').toggleClass('mobile-menu-open');
        $('#menu-toggler-open').toggleClass('d-block d-none');
        $('#menu-toggler-close').toggleClass('d-none d-block');
    });

    /*
     * Cache Current Window Wisth
     */
    var cachedWidth = $(window).width();

    /*
     * Resize Handler
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    $(window).resize(function() {
        var newWidth = $(window).width();
        if (newWidth !== cachedWidth) {
            if ($('html').hasClass('mobile-menu-open')) {
                $('html').removeClass('mobile-menu-open');
                $('.mobile-menu-container').toggleClass('d-none');
                $('#menu-toggler-open').toggleClass('d-block d-none');
                $('#menu-toggler-close').toggleClass('d-none d-block');
            }
            cachedWidth = newWidth;
        }
    });

    /*
     * Off Sidebar Click To Close Handling
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    $(document).mouseup(function(evt) {
        if ($('body').hasClass('sidebar-open')) {
            var elements = '.menu, .menu-toggle, .sidebar, .menu-socials, .sidebar-search';
            if (! $(elements).is(evt.target) && $(elements).has(evt.target).length === 0) {
                $('.sidebar').removeClass('open');
                $('body').removeClass('sidebar-open');
            }
        }
    });
});
